import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = o((a, e) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: e,
    ...a,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3689",
              width: 16,
              height: 17,
              x: 0,
              y: -1,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M6.56 16c-.35 0-.66-.25-.73-.6-.04-.19-.98-4.59-5.23-5.47a.75.75 0 0 1-.58-.89c.08-.41.48-.67.88-.58 2.88.6 4.51 2.48 5.4 4.09C7.15 9.13 9.36 3.26 14.88.1a.74.74 0 0 1 1.02.28c.21.36.08.82-.28 1.02-7.24 4.14-8.3 13.83-8.31 13.92a.76.76 0 0 1-.71.68z"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3689)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyCheckmarkIcon";
export {
  i as AgencyCheckmarkIcon,
  i as default
};
//# sourceMappingURL=index.js.map
